import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/expectedNotifyResult`;

export const ROUTE: RouteDefinition = `${baseRoute}/expectedNotifyResult`;

export const URL = (): RouteDefinition => `${baseRoute}/expectedNotifyResult`;
